import * as React from "react";
const SvgRefresh = (props) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 128 128",
	height: 128,
	width: 128,
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("g", { transform: "matrix(5.333333333333333,0,0,5.333333333333333,0,0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M5.25 14.248L5.25 18.748 0.75 18.748",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M18.75 9.748L18.75 5.248 23.25 5.248",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M19.032,5.245A9.752,9.752,0,0,1,8.246,21",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M4.967,18.751A9.753,9.753,0,0,1,15.754,3",
	fill: "none",
	stroke: "#000000",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5
})));
export { SvgRefresh as ReactComponent };
